module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/polls/polls.component.scss
// module id = 583
// module chunks = 1